import React, { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Phone, ArrowLeft, Shield, Clock, Headphones } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";

export default function ConfirmationPage() {
  const navigate = useNavigate();

  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "conversion", {
        send_to: "AW-18011987412/oGq0CN-S7J0cENS75IxD",
        value: 1.0,
        currency: "CHF",
      });
    }
  }, []);

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-slate-50 blueprint-bg flex items-center justify-center px-2 sm:px-4 py-6 sm:py-12 overflow-x-hidden pt-20">
      <div className="w-full max-w-lg">
        <div
          className="bg-white border-2 border-slate-200 rounded-md overflow-hidden"
          style={{ boxShadow: "6px 6px 0px rgba(30, 90, 158, 0.15)" }}
          data-testid="confirmation-card"
        >
          {/* Header */}
          <div className="bg-primary px-4 sm:px-6 py-6 sm:py-8 text-center">
            <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-md bg-white/10 border-2 border-white/20 flex items-center justify-center mx-auto mb-4">
              <CheckCircle2 className="w-8 h-8 sm:w-10 sm:h-10 text-accent" />
            </div>
            <h1
              className="text-xl sm:text-2xl md:text-3xl font-black text-white mb-1 sm:mb-2"
              style={{ fontFamily: "Barlow, sans-serif" }}
            >
              Merci pour votre demande&nbsp;!
            </h1>
            <p className="text-blue-200 text-xs sm:text-base">
              Votre demande de démo a bien été enregistrée
            </p>
          </div>

          {/* Body */}
          <div className="px-4 sm:px-6 py-6 sm:py-8 space-y-5 sm:space-y-6">
            <div className="text-center">
              <p className="text-base sm:text-lg text-slate-700 leading-relaxed">
                Notre <strong className="text-primary">agent virtuel</strong> va
                vous appeler dans les prochaines minutes pour vous faire une{" "}
                <strong className="text-accent">démo personnalisée</strong> de
                notre solution.
              </p>
            </div>

            <div className="flex items-center justify-center gap-3 bg-accent/10 border border-accent/30 rounded-md p-3 sm:p-4 w-full">
              <Phone className="w-5 h-5 sm:w-6 sm:h-6 text-accent animate-pulse flex-shrink-0" />
              <span className="text-accent font-bold text-base sm:text-lg">
                Restez près de votre téléphone
              </span>
            </div>

            <div className="space-y-2 sm:space-y-3">
              {[
                { icon: Clock, text: "Appel dans les prochaines minutes" },
                { icon: Headphones, text: "Démo personnalisée par notre agent IA" },
                { icon: Shield, text: "Sans engagement, 100% gratuit" },
              ].map((item) => {
                const Icon = item.icon;
                return (
                  <div
                    key={item.text}
                    className="flex items-center gap-3 bg-slate-50 border border-slate-200 rounded-md p-3"
                  >
                    <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-md bg-primary/10 flex items-center justify-center flex-shrink-0">
                      <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-primary" />
                    </div>
                    <span className="text-slate-700 font-medium text-sm">
                      {item.text}
                    </span>
                  </div>
                );
              })}
            </div>

            <Button
              onClick={() => navigate("/")}
              variant="outline"
              className="w-full border-2 border-primary text-primary hover:bg-primary hover:text-white font-semibold py-4 sm:py-5 rounded-md transition-all"
              data-testid="confirmation-back-btn"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Retour à la page d'accueil
            </Button>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}
